import React, { useState , useEffect} from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/login.css";
import Logo from "../assets/img/Logo.png";
import { FaEye, FaEyeSlash } from "react-icons/fa";


function LoginPage() {
    const [showPassword, setShowPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const { login } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const [successMessage, setSuccessMessage] = useState(location.state?.successMessage || '');

    useEffect(() => {
    if (successMessage) {
      const timer = setTimeout(() => {
        setSuccessMessage('');
      }, 5000); // Ocultar mensaje en 4 segundos

      return () => clearTimeout(timer); // Limpiar si el componente se desmonta
    }
    }, [successMessage]);

    // Obtener la ruta original a la que el usuario intentaba acceder
    const from = location.state?.from || "/reportes-general";

    const togglePasswordVisibility = () => setShowPassword(!showPassword);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrorMessage("");
        setIsLoading(true);

        const formData = new FormData(e.target);
        const email = formData.get("email");
        const password = formData.get("password");

        if (!email || !password) {
            setErrorMessage("Por favor complete todos los campos.");
            setIsLoading(false);
            return;
        }

        try {
            const result = await login({ email, password });

            if (result.success) {
                navigate(from);
            } else {
                setErrorMessage(result.error || "Error al iniciar sesión");
            }
        } catch (error) {
            setErrorMessage(error.message || "Error inesperado al iniciar sesión");
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="general-login">
            <div className="cuadro-login">
                <a href="/" className="logo">
                    <img src={Logo} alt="Logo" />
                </a>
                <div className="pt-2 pb-1 text-center">
                    <h3 className="card-title my-3">
                        <a className="text-decoration-none text-dark">
                            Inicio de Sesión
                        </a>
                    </h3>
                </div>

                {errorMessage && (
                    <div className="alert alert-danger" role="alert">
                        {errorMessage}
                    </div>
                )}

                <div>
                    {successMessage && <div className="alert alert-success">{successMessage}</div>}
                </div>

                <form
                    className="input-login row g-3 needs-validation"
                    onSubmit={handleSubmit}
                    noValidate
                >
                    <div className="col-12">
                        <input
                            type="email"
                            name="email"
                            className="form-control-login"
                            placeholder="Correo Electrónico"
                            required
                            disabled={isLoading}
                        />
                        <div className="invalid-feedback">Por favor ingrese su correo.</div>
                    </div>

                    <div className="col-12 position-relative">
                        <input
                            type={showPassword ? "text" : "password"}
                            name="password"
                            placeholder="Contraseña"
                            className="form-control-login"
                            required
                            disabled={isLoading}
                        />
                        <button
                            type="button"
                            className="password-toggle-btn"
                            onClick={togglePasswordVisibility}
                            disabled={isLoading}
                        >
                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                        </button>
                        <div className="invalid-feedback">Por favor ingrese su contraseña.</div>
                    </div>

                    <a href="/forgot-password" className="text-center">¿Olvidó su contraseña?</a>

                    <div className="boton-login">
                        <button
                            className="btn btn-primary"
                            type="submit"
                            disabled={isLoading}
                        >
                            {isLoading ? "Iniciando sesión..." : "Iniciar Sesión"}
                        </button>
                    </div>
                    <br></br>
                    {/*<a className="mb-2 text-center text-decoration-none" href="/register">Registrarme</a>*/}

                </form>
            </div>
        </div>
    );
}

export default LoginPage;